<ng-container *ngIf="viewState$ | async as viewState">
    <ng-container ntapItemProvider>
        <ng-container ntapItemViewProvider viewName="arhiv_posjednik_item" [viewState]="viewState">
            <p-card header="Moja institucija">
                <ntap-prime-common-itemview></ntap-prime-common-itemview>
            </p-card>
        </ng-container>
    </ng-container>
</ng-container>